import { I18n } from "@/i18n/I18n";
import { Button, Modal } from "react-bootstrap";

export function ConfirmModal(props: { title?: string, confirmMessage: string, onConfirm: () => Promise<unknown>, setShowModal: (show: boolean) => void, confirmText?: string, cancelText?: string }) {
  const { title, confirmMessage, onConfirm, setShowModal, confirmText, cancelText } = props;

  const confirmAction = async () => {
    await onConfirm();
    setShowModal(false);
  };

  return (
    <Modal show onHide={() => setShowModal(false)}>
      <Modal.Header className="bg-danger text-white">
        <Modal.Title>{title || I18n.get('confirm')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{confirmMessage}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={() => setShowModal(false)}>{cancelText || I18n.get('cancel')}</Button>
        <Button variant='danger' onClick={() => void confirmAction()}>{confirmText || I18n.get('confirm')}</Button>
      </Modal.Footer>
    </Modal>
  );
}